import { alpha } from '@mui/material/styles';

export type IPalette = {
    [key: string]: {
        [key: string]: string;
    };
};

export const palette = {
    primary: {
        main: '#19765E',
        dark: '#12725C',
        light: '#B1BCB1',
        contrastText: '#FFFFFF',
    },
    secondary: {
        main: '#C0A4AE',
        dark: '#CA6E72',
        light: '#CDA1A5',
        contrastText: '#FFFFFF',
    },
    error: {
        main: '#B20000',
        dark: '#CC1A33',
        light: '#EA586C',
        contrastText: '#FFFFFF',
    },
    warning: {
        main: '#FBC815',
        dark: '#D3A403',
        light: '#FFD54F',
        contrastText: '#FFFFFF',
    },
    info: {
        main: '#0065C1',
        dark: '#01579B',
        light: '#4A647C',
        contrastText: '#FFFFFF',
    },
    success: {
        main: '#007505',
        dark: '#5E8731',
        light: '#7AB040',
        contrastText: '#FFFFFF',
    },
    background: {
        default: '#E9D8D2',
        paper: '#FFFFFF',
        table1: '#EEF1F1',
        table2: '#DDE3E4',
    },
    text: {
        primary: '#555965',
        secondary: alpha('#000000', 0.6),
        disabled: alpha('#000000', 0.38),
    },
};
